import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { PurchaseProcess } from '@Purchasing/Domain/Model/PurchaseProcess'
import { useCallback, useEffect, useState } from 'react'

export const usePurchaseProcessById = (id?: string) => {
    const useCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseGetPurchaseProcessById
    )
    const [process, setProcess] = useState<PurchaseProcess | null>(null)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const load = useCallback(async () => {
        if (!id) return
        setLoading(true)
        setError(null)
        try {
            const result = await useCase.execute(id)
            setProcess(result)
        } catch (e: any) {
            console.error(e)
            setError(
                e?.response?.data?.message ?? 'Erro ao carregar o processo'
            )
        }
        setLoading(false)
    }, [useCase, id])

    useEffect(() => {
        load()
    }, [load])

    return {
        process,
        loading,
        error,
        reload: load,
    }
}
